import AbstractLayerManager from './AbstractLayerManager';
import Request from '../../Request';
import {sprintf} from 'sprintf-js';

export default class ConvectiveLayerManager extends AbstractLayerManager {
	constructor(myKey, instance) {
		super(myKey, instance);
		this.name = "Mesoscale Discussion";
		this.popupName = "Mesoscale Discussion";
		this.options.hasPanRefresh = false;
		this.options.hasAutoRefresh = true;
	}
	
	refreshLayer() {
		this.requestData();
	}
	
	requestData() {
		this.inst.setLoadingMonitor(this.id, true);

		if(this.tasks.fetchData === undefined) this.tasks.fetchData = new Request({
			url: 'https://api.weatherusa.net/v1/feed/specprod',
			data: {product_id: 'SWO'},
			link: 'cancel',
			timeout: 30000,
			onSuccess: this.handleResp.bind(this),
			onError: this.handleError.bind(this)
		});

		this.tasks.fetchData.get();
	}

	handleError(err) {
		console.error(err);
		this.inst.setLoadingMonitor(this.id, false);
	}
	
	handleResp(resp) {
		if(!this.layer) {
			console.error('Could not find layer for layer ID: ' + this.id);
			return false;
		}
		
		let list = resp.body;
		// Remove all paths from LayerGroup
		this.layer.clearLayers();

		for(const [id, data] of Object.entries(list)) {
			var polyPath = [];
			for(const pt of data.poly) {
				polyPath.push(new L.LatLng(pt[0], pt[1]));
			}
			var obj = new L.Polygon(polyPath, {
				fillColor: data.fill,
				fillOpacity: 0.11,
				color: data.outl,
				weight: 2,
				opacity: 1.0
			})
			.on('click', this.handleClick, this)
			.addTo(this.layer);
			obj.nwsProductId = data.id;
			obj.details = data.text;
			obj.eventId = data.eventId;
		}

		this.inst.setLoadingMonitor(this.id, false);
	}

	handleClick(e) {
		var eventSPC = sprintf('%04u', e.target.eventId);
		this.inst.forwardedClickHandler(this.id, e, '<div class="alerts-text-view"><a target="_blank" href="https://www.spc.noaa.gov/products/md/md' + eventSPC + '.html"><img class="img-responsive" src="https://www.spc.noaa.gov/products/md/mcd' + eventSPC + '.gif" /></a><br /><br />' + e.target.details + '</div>');
	}

	getLayerPopupContent(layer) {
		var eventSPC = sprintf('%04u', layer.eventId);
		return '<div class="alerts-text-view"><a target="_blank" href="https://www.spc.noaa.gov/products/md/md' + eventSPC + '.html"><img class="img-responsive" src="https://www.spc.noaa.gov/products/md/mcd' + eventSPC + '.gif" /></a><br /><br />' + e.target.details + '</div>';
	}
}
